




























































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {Line, Option, SegmentationResource} from '@/types/gripper';
import OptionSideBar from '@/layouts/gripper/components/OptionSideBar.vue';
import TaskElaboration from '@/layouts/gripper/components/TaskElaboration.vue';
import {
  JobDatasetSegmentation, JobInfo,
  JobInfo_job_task_parameter,
  UpdateJobResourceCheckInput,
} from '@/types/intrador';
import IntradorLoader from '@/layouts/gripper/components/QuickLabeling/IntradorLoader.vue';
import {SmartQuery} from 'vue-apollo/types/vue-apollo';
import PaginateButtonsShrinkingBin from '@/layouts/gripper/components/QuickLabeling/PaginateButtonsShrinkingBin.vue';
import DirectionSwitch from '@/layouts/back-office/misc/DirectionSwitch.vue';

@Component({
  components: {
    OptionSideBar,
    TaskElaboration,
    IntradorLoader,
    PaginateButtonsShrinkingBin,
    DirectionSwitch,
  },
})

export default class CanvasSegmentation extends Vue {

  @Prop(Object) public jobInfo!: JobInfo;
  @Prop(Array) public options!: Option[];
  @Prop(Object) private parameter!: JobInfo_job_task_parameter;

  private JobDataset!: JobDatasetSegmentation;
  private page: number = 1;
  private limit: number = 1;
  private totalPages: number = 0;

  private resource: SegmentationResource | null = null;
  private segmentationImage: any = new Image();
  private stageWidth: number = 0;
  private stageHeight: number = 0;

  private index = -1;
  private pointIndex = -1;
  private lines: Line[] = [];
  private onlyPredictions: boolean = false;

  get queryVariables() {
    let predictionInputs: any[] = [];
    if (this.onlyPredictions) {
      predictionInputs = [{
        has: this.onlyPredictions,
        parameter_id: this.parameter.id,
      }];
    }

    return {
      jobID: this.jobInfo!.job!.id,
      page: this.page,
      limit: this.limit,
      parameter_id: this.parameter.id,
      predictionInputs,
      checkInputs: [{
        has: false,
        parameter_id: this.parameter.id,
      }],
    };
  }

  private resolveData(data: JobDatasetSegmentation) {
    if (!data || !data.job || !data.job.dataset || !data.job.dataset.resources) {
      return false;
    }

    this.JobDataset = data;

    this.totalPages = Math.ceil(data.job.dataset.resources.paginatorInfo.total / this.limit);
    this.resolveImagesData(data);

    return data;
  }

  private resolveImagesData(data: JobDatasetSegmentation) {
    if (!data || !data.job || !data.job.dataset || !data.job.dataset.resources) {
      return false;
    }

    // Only get the first item
    const item = data.job.dataset.resources.data[0];

    if (item) {

      let predValue = null;
      let checkValue = null;
      if (item.predictions && item.predictions.length > 0) {
        if (item.predictions[0]) {
          predValue = item.predictions[0].value;
        }
      }

      if (item.checks && item.checks.length > 0) {
        if (item.checks[0]) {
          checkValue = item.checks[0].value;
        }
      }

      const resource: SegmentationResource = {
        id: item.id,
        url: item.url + '?job_id=' + data.job?.id,
        check_value: checkValue,
        pred_value: predValue,
        isMutating: false,
        isDeleted: false,
      };

      this.resource = resource;

      this.segmentationImage = new Image();
      this.segmentationImage.onload = () => {
        this.fitStageIntoWindow();
      };
      this.segmentationImage.src = resource.url;

      window.addEventListener('resize', this.fitStageIntoWindow);

      if (resource.pred_value) {
        this.lines = JSON.parse(resource.pred_value);
        this.fillLines();
      } else if (resource.check_value) {
        this.lines = JSON.parse(resource.check_value);
        this.fillLines();
      } else {
        this.addNewLine();
      }
    }
  }

  private fillLines() {
    this.lines.forEach((line: any) => {
      line.stroke = null;
      line.strokeWidth = 2;
      line.fill = '#0A97B0';
      line.closed = true;
      line.opacity = 0.5;
    });
  }

  private fitStageIntoWindow() {
    this.stageWidth = window.innerWidth - 90;
    this.stageHeight = window.innerHeight - 90;

    this.segmentationImage.width = this.stageWidth;
    this.segmentationImage.height = this.stageHeight;

    (this.$refs.imageLayer as any).getNode().batchDraw();
  }

  private getRelativePoints(line: Line, width: number, height: number) {
    return line.points.map((x: any) => {
      return [x[0] * width, x[1] * height];
    });
  }

  private addNewLine() {
    this.lines.push({
      points: [],
      stroke: null,
      strokeWidth: 2,
      fill: '#0A97B0',
      closed: true,
      opacity: 0.5,
      tension: null,
      fillEnabled: true,
      tool: 'pen',
    });
    this.index = this.lines.length - 1;
  }

  private addPoint(node: any) {
    const position = node.target.getStage().getPointerPosition();
    const point = [position.x / this.stageWidth, position.y / this.stageHeight];
    this.pointIndex++;
    this.lines[this.lines.length - 1].points.splice(this.pointIndex, 0, point);

    // Redraw Image
    (this.$refs.lineLayer as any).getNode().batchDraw();
  }

  private preventDefault(node: any) {
    node.evt.preventDefault();
  }

  private selectLine(node: any) {
    this.index = node.target.attrs.line;
  }

  private selectPoint(node: any) {
    if (node.target.className === 'Circle') {
      this.pointIndex = node.target.attrs.point;
      this.index = node.target.attrs.line;

      // Redraw Image
      (this.$refs.lineLayer as any).getNode().batchDraw();
    }
  }

  private updatePoint(node: any) {
    if (node.target.className === 'Circle') {
      this.selectPoint(node);
      const position = node.target.getStage().getPointerPosition();
      const point = [position.x / this.stageWidth, position.y / this.stageHeight];

      Vue.set(this.lines[this.index].points, this.pointIndex, point);

      // Redraw Image
      (this.$refs.lineLayer as any).getNode().batchDraw();
    }
  }

  private removePoint(node: any) {
    if (node.target.className === 'Circle') {
      this.selectPoint(node);
      this.lines[this.index].points.splice(this.pointIndex, 1);
      this.pointIndex = this.lines[this.index].points.length - 1;

      // Redraw Image
      (this.$refs.lineLayer as any).getNode().batchDraw();
    }
  }

  private async persistToDatabase() {
    if (this.resource) {
      this.resource.isMutating = true;

      const variables = this.resolveUpdateJobResourceValueInput(this.resource);
      if (variables !== undefined) {
        try {
          await this.$apollo.mutate({
            mutation: require('@/graphql/mutations/UpdateJobResourceCheck.graphql'),
            variables: {input: variables},
          });
        } catch (error) {
          await this.$swal('Error', error.message, 'warning');
        }
      }
      this.resource.isMutating = false;
    }
  }

  private async pageChange(newPage: number) {
    if (this.JobDataset &&
      this.JobDataset.job &&
      this.JobDataset.job.dataset &&
      this.JobDataset.job.dataset.resources) {

      await this.persistToDatabase();
      this.refetch();
    }
  }

  private get queryResult(): SmartQuery<any> {
    return (this.$refs.apolloQuery as any).getApolloQuery();
  }

  private refetch() {
    this.lines = [];
    this.resource = null;
    if (this.queryResult) {
      this.queryResult.refresh();
    }
  }

  private get canChangePage(): boolean {
    if (this.resource) {
      return !this.resource.isMutating;
    }
    return false;
  }

  private resolveUpdateJobResourceValueInput(resource: SegmentationResource) {
    if (!this.jobInfo || !this.jobInfo.job) {
      return;
    }
    if (this.lines.length > 0) {
      return {
        job_id: this.jobInfo.job.id,
        resource_id: resource.id,
        value: JSON.stringify(this.lines),
        option_id: null,
      } as UpdateJobResourceCheckInput;
    }
  }
}
